import {Injectable} from "@angular/core";
import {Api} from "../api.service";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {User} from "../api/users/api.models";
import {AuthenticationService} from "../authentication.service";
import {Permission} from "../api/permissions/api.models";

@Injectable()
export class UsersResolver implements Resolve<any>
{
    constructor(private api: Api, private auth: AuthenticationService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<User[]> {
        return Observable.create((mainObservable) => {
            if (this.auth.canDoAny([Permission.USERS_READ, Permission.USERS_READ_ALL]) === false) {
                mainObservable.next([]);
                mainObservable.complete();
                return;
            }

            return this.api.users().collection().toPromise().then(
                (result: User[]) => {
                    let users = [];

                    result.forEach((user: User) => {
                        if (user.isHidden === false) {
                            users.push(user);
                        }
                    });

                    mainObservable.next(users);
                    mainObservable.complete();
                },
                (error: any) => {
                    mainObservable.error({message: error, ngNavigationCancelingError: true});
                }
            );
        });
    }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/resolvers/users.resolver.ts